import React from 'react';
import { Popup, ToolbarItem } from "devextreme-react/popup";

const VerifyPopup = ({ popupMessageContent, isMessagePopupVisible, setMessagePopupVisibility, type, customFunction ,title,button1Text,button2Text}) => {

    const handleDismiss = () => {
        setMessagePopupVisibility(false);
        // onDismiss(); // Call the onDismiss callback passed from the parent component
    };

    const approveButtonOptions = {
        text: button1Text,
        stylingMode: "contained",
        onClick: () => {
            handleDismiss();
            customFunction(); // Call your custom function here
        },
    };

    const cancelButtonOptions = {
        text: button2Text,
        stylingMode: "outlined",
        onClick: handleDismiss,
    };

    return (
        <>
            {isMessagePopupVisible && (
                <div
                    style={{padding: '10px', color: 'white', margin: "10px" }}
                >
                    <Popup
                        visible={isMessagePopupVisible}
                        showTitle={true}
                        title= {title}
                        showCloseButton={false}
                        width={300}
                        height={180}
                    >
                       {popupMessageContent}
                        <ToolbarItem
                            widget="dxButton"
                            toolbar="bottom"
                            location="after"
                            options={approveButtonOptions}
                        />
                        <ToolbarItem
                            widget="dxButton"
                            toolbar="bottom"
                            location="center"
                            options={cancelButtonOptions}
                        />
                    </Popup>
                </div>
            )}
        </>
    );
};

export default VerifyPopup;
